import { Box, Text } from 'braid-design-system';
import React from 'react';

import { getCharacterCount } from 'src/app/utils/getCharacterCount';

import * as styles from './index.css';

interface CharacterCounterProps {
  maxLength: number;
  currentLength?: number;
  value?: string;
}

export const CharacterCounter = ({
  currentLength,
  maxLength,
  value,
}: CharacterCounterProps) => {
  const calculatedCurrentLength = currentLength || getCharacterCount(value);

  if (calculatedCurrentLength <= 0) {
    return null;
  }

  const remainingLength = maxLength - calculatedCurrentLength;
  const tone = remainingLength < 0 ? 'critical' : 'secondary';

  return (
    <Box className={styles.root}>
      <Text tone={tone}>{remainingLength}</Text>
    </Box>
  );
};
